module.exports = __webpack_public_path__ + "static/media/relax.dc188e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PromotionCards/relax.jpg
// module id = 818
// module chunks = 0